import QueryBuilder, { QueryInterface } from "./QueryBuilder";
const Query = (elementId: undefined | string | string[]): QueryInterface => {
  return new QueryBuilder(elementId);
};
export default Query;
